export default "__VITE_ASSET__CyLX6g5q__"